import React from 'react';
import { DeveloperSaleBadge } from './dev-sale-badge';
import { WixSaleBadge } from './wix-sale-badge';
import { BetaBadge } from './beta-badge';
import { WixChoiceBadge } from './wix-choice-badge';
import { AppBadgesType } from '@wix/app-market-services';
import type { AppBadge } from '@wix/app-market-services';
import { useEssentials } from '../../contexts/essentials-context';
import { AppBenefitsBadge } from './app-benefits-badge';

interface AppBadgesProps {
  appBadges: AppBadge[];
  appName: string;
  showBorder?: boolean;
  isInstalled?: boolean;
  size?: 'tiny' | 'small' | 'medium';
  wixSaleSize?: 'small' | 'big';
  languageCode?: string;
  maxCount?: number;
}

export function AppBadges({
  appBadges,
  appName,
  showBorder = false,
  isInstalled,
  size = 'small',
  languageCode = 'en',
  maxCount = 2,
}: AppBadgesProps) {
  const { experiments } = useEssentials();
  const showNovemberSaleBadge =
    experiments?.enabled('specs.app-market.Sale') ?? false;

  const hasAppBenefit = appBadges.some(({ badge }) => badge === AppBadgesType.APP_BENEFIT);

  return (
    <>
      {appBadges
        .filter(({ badge }) => !(badge === AppBadgesType.PREMIUM_BENEFIT && hasAppBenefit))
        .map(({ badge, discountBadgePayload }) => {
          switch (badge) {
            case AppBadgesType.BETA:
              return <BetaBadge {...{ appName, showBorder, size }} />;
            case AppBadgesType.WIX_CHOICE:
              return <WixChoiceBadge {...{ showBorder, size }} />;
            case AppBadgesType.PREMIUM_BENEFIT:
              return (
                <AppBenefitsBadge
                  {...{ appName, showBorder, size, isInstalled }}
                />
              );

            case AppBadgesType.APP_BENEFIT:
              return (
                <AppBenefitsBadge
                  {...{ appName, showBorder, size, isInstalled }}
                />
              );
            case AppBadgesType.WIX_SALE:
              if (showNovemberSaleBadge) {
                return (
                  <WixSaleBadge
                    amount={discountBadgePayload?.amount!}
                    size={size}
                  />
                );
              }
              return undefined;
            case AppBadgesType.DEV_SALE:
              return (
                <DeveloperSaleBadge
                  amount={discountBadgePayload?.amount!}
                  endDate={discountBadgePayload?.endDate || undefined}
                  languageCode={languageCode}
                  {...{ showBorder, size }}
                />
              );
            default:
              return undefined;
          }
        })
        .slice(0, maxCount)}
    </>
  );
}

export default AppBadges;
